import React from 'react'
import FJFetchError from "./FJFetchError";
import FJNoResults from "./FJNoResults";
import FJPureLoading from "./FJPureLoading";
import FJScrollEndTip from "./FJScrollEndTip";
import FJCustomScroll from 'fj-components/FJCustomScroll';
import FJViewConstant from "../../../../constant/FJViewConstant";
import FJStockListTitle from "./FJStockListTitle";

function FJSearchCommonView(props) {
  const {renderList, status, keywords, searchNextPage, className, onRetry, info} = props;
  const {
    STOCK_SEARCH_END,
    STOCK_SEARCH_NONE,
    STOCK_SEARCH_ERROR,
    STOCK_SEARCH_LOADING,
    STOCK_SEARCH_SUBLOADING
  } = FJViewConstant;
  const hasList = status !== STOCK_SEARCH_LOADING && status !== STOCK_SEARCH_ERROR && status !== STOCK_SEARCH_NONE;
  const {total, type} = info || {total: 0, type: ''};
  const eventScroll = (event) => {
    const {scrollTop, clientHeight, scrollHeight} = event.target;

    // 向上取整的目的是避免小数造成无法相等
    if (Math.ceil(scrollTop + clientHeight) === scrollHeight && hasList && status !== STOCK_SEARCH_END) {
      searchNextPage(keywords);
    }
  };

  return (
    <div className={className}>
      {
        hasList &&
        <FJCustomScroll onScroll={eventScroll}>
          {info && <FJStockListTitle total={total} keywords={keywords} type={type}/>}
          {renderList()}
          <FJScrollEndTip active={status === STOCK_SEARCH_END}/>
          <FJPureLoading active={status === STOCK_SEARCH_SUBLOADING} type='next'/>
        </FJCustomScroll>
      }
      {
        info && status !== STOCK_SEARCH_ERROR && <FJStockListTitle total={total} keywords={keywords} type={type}/>
      }
      <FJFetchError onRetry={onRetry} active={status === STOCK_SEARCH_ERROR}/>
      <FJNoResults keywords={keywords} active={status === STOCK_SEARCH_NONE}/>
      <FJPureLoading active={status === STOCK_SEARCH_LOADING} type='content'/>
    </div>
  );
}

export default FJSearchCommonView;